export default class DetectDevice {
  constructor (userAgent) {
    this.userAgent = userAgent
  }

  isIos () {
    return !!this.userAgent.match(/(iPad|iPhone|iPod)/i)
  }

  isAndroid () {
    const userAgent = this.userAgent.toLowerCase()

    return userAgent.indexOf('android') > -1
  }
}
